import {
  CardFace,
  ContentType,
} from '../types/flipcardTypes';
import {I18nStrings} from '../i18n';
import {
  flipcardCardActionAttr, flipcardCardContentTypeAttr, flipcardCardFaceAttr,
  flipcardCardIdAttr,
  flipcardCardNumberAttr,
  flipcardPluginName
} from "@/components/tinyMce/plugins/flipcard/flipcardConstants";
import {customPluginNameAttr} from "@/components/tinyMce/plugins/tinyMceCustomPluginsConstants";

let cardCounter = 0;
export function generateCardId(): string {
  return `flipcard-${Date.now()}-${cardCounter}`;
}

export function createEmptyCard(i18n: I18nStrings): string {
  const cardId = generateCardId();
  const cardNumber = 1;

  return `<div class="flipcard-super-container">&nbsp;&nbsp;<div class="flipcard-container" ${customPluginNameAttr}="${flipcardPluginName}" ${flipcardCardIdAttr}="${cardId}" ${flipcardCardNumberAttr}="${cardNumber}" contenteditable="false">
    ${createHeader(cardNumber, 'front', i18n)}
    <div class="flipcard-inner">
      ${createFace('front', { type: 'empty', value: '' }, i18n, true)}
      ${createFace('back', { type: 'empty', value: '' }, i18n, false)}
    </div>
    ${createFooter('front', i18n)}
  </div>&nbsp;&nbsp;</div>`;
}

export function createHeader(cardNumber: number, activeFace: CardFace, i18n: I18nStrings): string {
  const title = i18n.cardTitle(cardNumber, activeFace);

  return `<div class="flipcard-header">
    <span class="flipcard-drag-handle" draggable="true" title="${i18n.dragHandle}">
      <i class="mdi mdi-drag-vertical"></i>
    </span>
    <span class="flipcard-title">${title}</span>
    <div class="flipcard-actions">
      <span class="action-button flipcard-btn-reset" ${flipcardCardActionAttr}="reset" title="${i18n.resetFace}" style="display: none;">
        <i class="mdi mdi-restore"></i>
      </span>
      <span class="action-button flipcard-btn-copy" ${flipcardCardActionAttr}="copy" title="${i18n.copyCard}">
        <i class="mdi mdi-content-copy"></i>
      </span>
      <span class="action-button flipcard-btn-delete" ${flipcardCardActionAttr}="delete" title="${i18n.deleteCard}">
        <i class="mdi mdi-delete-outline"></i>
      </span>
    </div>
  </div>`;
}

export function createFace(face: CardFace, content: { type: ContentType; value: string }, i18n: I18nStrings, isActive: boolean): string {
  const activeClass = isActive ? 'active' : '';
  const hasContent = content.type !== 'empty' && content.value;

  return `<div class="flipcard-face flipcard-${face} ${activeClass}" ${flipcardCardFaceAttr}="${face}">
    <div class="flipcard-content-options ${hasContent ? 'hidden' : ''}">
      <span class="flipcard-option-text" ${flipcardCardActionAttr}="add-text">
        <i class="mdi mdi-text"></i>
        <span>${i18n.addText}</span>
      </span>
      <div class="flipcard-separator">${i18n.or}</div>
      <span class="flipcard-option-image" ${flipcardCardActionAttr}="add-image">
        <i class="mdi mdi-image-outline"></i>
        <span>${i18n.addImage}</span>
      </span>
    </div>
    <div class="flipcard-content ${hasContent ? 'has-content' : ''}" ${flipcardCardContentTypeAttr}="${content.type}">
      ${renderContent(content)}
    </div>
  </div>`;
}

export function renderContent(content: { type: ContentType; value: string }): string {
  if (content.type === 'text' && content.value) {
    return `<div contenteditable="true" class="flipcard-text-content">${escapeHtml(content.value)}</div>`;
  }

  if (content.type === 'image' && content.value) {
    return `<img src="${escapeHtml(content.value)}" alt="Card image" />`;
  }

  return '';
}

export function createFooter(activeFace: CardFace, i18n: I18nStrings): string {
  const flipText = activeFace === 'front' ? i18n.flipToBack : i18n.flipToFront;

  return `<div class="flipcard-footer">
    <span class="flipcard-btn-flip" ${flipcardCardActionAttr}="flip">
      <i class="mdi mdi-rotate-3d-variant"></i>
      <span class="flipcard-btn-flip-text">${flipText}</span>
    </span>
  </div>`;
}

export function updateCardHeader(container: HTMLElement, cardNumber: number, activeFace: CardFace, i18n: I18nStrings): void {
  const titleElement = container.querySelector('.flipcard-title');
  if (titleElement) {
    titleElement.textContent = i18n.cardTitle(cardNumber, activeFace);
  }
}

export function updateFooterButton(container: HTMLElement, activeFace: CardFace, i18n: I18nStrings): void {
  const button = container.querySelector('.flipcard-btn-flip-text');
  if (button) {
    button.textContent = activeFace === 'front' ? i18n.flipToBack : i18n.flipToFront;
  }
}

export function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
